import { useFetchCallType } from '@rahtab/auth/lib/token-based-auth';
import { useAppDispatch, useSelector } from 'rahtab-redux';
import { useEffect } from 'react';
import { addMerchandiseInventory, inventoryMerchandiseSelector } from 'rahtab-redux/slices/merchandiseInventorySlice';
import { addMerchandise } from 'rahtab-redux/slices/merchandisesSlice';
import { useState } from 'react';

export const useMerchandiseInventory = (id: string) => {
  const dispatch = useAppDispatch();
  const [idList, setIdList] = useState<Set<string> | undefined>();
  const { categories } = useSelector((state) => state.category);
  const { categoryInventory } = useSelector((state) => state.categoryInventory);
  const { loading: loadsLoading } = useSelector((state) => state.merchandiseInventory);
  const merchandiseInventory = useSelector(inventoryMerchandiseSelector(Array.from(idList?.values() || [])));
  const [refetch, { called, loading }] = useFetchCallType<ServerMerchandiseInventoryItem[]>('GetInventoryTemplates', {
    params: `ProductCode=${id}`,
    onCompleted: (d) => {
      let temp = new Set(idList);
      d.forEach((mer) => {
        temp.add(mer.TemplateCode);
        dispatch(addMerchandiseInventory(mer));
        dispatch(addMerchandise(mer));
      });
      setIdList(temp);
    },
  });
  useEffect(() => {
    if (loadsLoading === 'refreshing') {
      refetch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadsLoading]);

  return {
    refetch,
    loading,
    called,
    data: {
      productInfo: {
        ...categories[id],
        ...categoryInventory[id],
      },
      merchandiseInventoryList: merchandiseInventory,
    },
  };
};

export interface ServerMerchandiseInventoryItem {
  TemplateCode: string;
  TemplateName: string;
  TemplateImage: string;
  StockRemainingValue: string;
  MeasureName: string;
  StatusCode: '0' | '1';
  Status: string;
  AssignFinallCount: string;
  TotalRemainingValue: string;
}

interface MerchandiseInventoryItem {
  id: string;
  name: string;
  image: string;
  loadCount: number;
  remainingCount: number;
  status: string;
  statusCode: 0 | 1;
  measureName: string;
}
